
const data = [
    {
        id: '7',
        text: 'A/B test App 2.0',
        hasPriority: true,
        isCompleted: true
    },
    {
        id: '8',
        text: 'Code animation for homepage hero',
        hasPriority: false,
        isCompleted: true
    },
    {
        id: '9',
        text: 'Test for latest changes on homepage',
        hasPriority: false,
        isCompleted: true
    },
    {
        id: '10',
        text: 'Contact stakeholder for shared library',
        hasPriority: false,
        isCompleted: true
    },

    {
        id: '1',
        text: 'Test for latest changes on homepage',
        hasPriority: true,
        isCompleted: false
    },
    {
        id: '2',
        text: 'New design system: brainstorming',
        hasPriority: true,
        isCompleted: false
    },
    {
        id: '3',
        text: 'Fix code on landing page',
        hasPriority: true,
        isCompleted: false
    },
    {
        id: '4',
        text: 'Replace broken CEO',
        hasPriority: true,
        isCompleted: false
    },
    {
        id: '5',
        text: 'Adjust gradients in home illustration',
        hasPriority: false,
        isCompleted: false
    },
    {
        id: '6',
        text: 'Send adv',
        hasPriority: false,
        isCompleted: false
    }
]

export default data
